import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  inject,
  signal,
} from '@angular/core'
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms'

import {
  FLX_MODAL_DATA,
  FlxButtonModule,
  FlxFormControlModule,
  FlxModalData,
  FlxModalModule,
  FlxModalService,
} from '@flowx/angular-ui-toolkit'
import { FlxSpinnerModule } from '@flowx/designer/shared/components/spinner'
import { FlxAutofocusDirective } from '@flowx/designer/shared/directives/autofocus.directive'
import { EnterSubmitFormDirective } from '@flowx/designer/shared/directives/enter-submit-form.directive'
import { BranchNameRegex } from '@flowx/designer/shared/entities/utils'
import { BRANCH_NAME_MAX_LENGTH } from '@flowx/designer/shared/versioning/versioning.utils'

@Component({
  selector: 'app-new-branch-modal',
  templateUrl: './new-branch-modal.component.html',
  styleUrls: ['./new-branch-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FlxModalModule,
    FlxFormControlModule,
    ReactiveFormsModule,
    FlxButtonModule,
    FlxSpinnerModule,
    FlxAutofocusDirective,
    EnterSubmitFormDirective,
  ],
})
export class NewBranchModalComponent {
  private modalService = inject(FlxModalService)
  @Output() dataEventEmitter = new EventEmitter<any>()

  maxLength = BRANCH_NAME_MAX_LENGTH
  branchNameFC = new FormControl<string>('', [
    Validators.required,
    Validators.maxLength(this.maxLength),
    Validators.pattern(BranchNameRegex),
  ])
  branchNameForm = inject(FormBuilder).group({
    branchName: this.branchNameFC,
  })

  data: FlxModalData = inject(FLX_MODAL_DATA)
  submitted = signal(false)

  createBranch(): void {
    this.submitted.set(true)
    if (this.branchNameFC.invalid) {
      return
    }
    this.dataEventEmitter.emit(this.branchNameFC.value)
    this.modalService.hide()
  }

  closeModal(): void {
    this.modalService.hide()
  }
}
